import { CheckIcon, SOSIcon } from '@dreryk/react-components';

import { assertUnreachable } from '~libs.typescript';

import { translationKeys } from '../translations';

import { EmergencyNotificationState, EmergencyNotificationVariant } from './useEmergencyNotification';
import { SmallIconWrapper } from './EmergencyNotificationButton.styled';

type EmergencyNotificationButtonConfig = {
   icon: JSX.Element;
   label: string;
};

export const getEmergencyNotificationButtonConfig = (
   state: EmergencyNotificationState,
   variant: EmergencyNotificationVariant
): EmergencyNotificationButtonConfig => {
   switch (state.type) {
      case 'idle':
         return {
            icon: <SOSIcon />,
            label: variant === 'test' ? translationKeys.testAlarm : translationKeys.sos,
         };
      case 'active':
         return {
            icon: (
               <SmallIconWrapper>
                  <CheckIcon />
               </SmallIconWrapper>
            ),
            label: translationKeys.sosSent,
         };
      case 'acknowledged':
         return {
            icon: <SOSIcon />,
            label: translationKeys.sosAssistanceOnTheWay,
         };
      default:
         return assertUnreachable();
   }
};
